import { createAction, createReducer } from "@reduxjs/toolkit";
import { get } from "lodash-es";

const MODULE_PREFIX = "[ACCOUNT_CLOSURE]";

// Actions
const Actions = {
  fetchPreCheck: `${MODULE_PREFIX} fetchPreCheck`,
  setPreCheck: `${MODULE_PREFIX} setPreCheck`,
  getDetails: `${MODULE_PREFIX} getDetails`,
  setDetails: `${MODULE_PREFIX} setDetails`,
  setReason: `${MODULE_PREFIX} setReason`,
  triggerOtp: `${MODULE_PREFIX} triggerOtp`,
  setOtpLinks: `${MODULE_PREFIX} setOtpLinks`,
  createEsign: `${MODULE_PREFIX} createEsign`,
  setEsignData: `${MODULE_PREFIX} setEsignData`,
  updateClosureStorage: `${MODULE_PREFIX} updateClosureStorage`,
  resetClosureStorage: `${MODULE_PREFIX} resetClosureStorage`,
  resetAccountClosure: `${MODULE_PREFIX} resetAccountClosure`,
  resetDetails: `${MODULE_PREFIX} resetDetails`,
};

export const fetchPreCheck = createAction(Actions.fetchPreCheck);
export const setPreCheck = createAction(Actions.setPreCheck);
export const getDetails = createAction(Actions.getDetails);
export const setDetails = createAction(Actions.setDetails);
export const resetDetails = createAction(Actions.resetDetails);
export const setReason = createAction(Actions.setReason);
export const triggerOtp = createAction(Actions.triggerOtp);
export const setOtpLinks = createAction(Actions.setOtpLinks);
export const createEsign = createAction(Actions.createEsign);
export const setEsignData = createAction(Actions.setEsignData);
export const updateClosureStorage = createAction(Actions.updateClosureStorage);
export const resetClosureStorage = createAction(Actions.resetClosureStorage);
export const resetAccountClosure = createAction(Actions.resetAccountClosure);

export const getPreCheckListData = (state) => {
  return get(state, "accountClosure.checklist", {});
};

export const getReason = (state) => {
  return get(state, "accountClosure.reason", {});
};

export const getOtpLinks = (state) => {
  return get(state, "accountClosure.otpLinks", {});
};

export const getClosureDetails = (state) => {
  return get(state, "accountClosure.details", {});
};

export const getEsignData = (state) => {
  return get(state, "accountClosure.esign", {});
};

export const getClosureStorage = (state) => {
  return get(state, "accountClosure.getClosureStorage", {});
};

const initialState = {
  checklist: {},
  details: {},
  reason: {
    value: "",
    remark: "",
  },
  otpLinks: {},
  esign: {},
  closureStorage: {},
};

export default createReducer(initialState, (builder) => {
  builder.addCase(setPreCheck, (state, action) => {
    state.checklist = action.payload;
  });
  builder.addCase(setDetails, (state, action) => {
    state.details = action.payload;
  });
  builder.addCase(setReason, (state, action) => {
    state.reason = action.payload;
  });
  builder.addCase(setOtpLinks, (state, action) => {
    state.otpLinks = action.payload;
  });
  builder.addCase(setEsignData, (state, action) => {
    state.esign = action.payload;
  });
  builder.addCase(updateClosureStorage, (state, action) => {
    state.closureStorage = {
      ...state.closureStorage,
      ...action.payload,
    };
  });
  builder.addCase(resetClosureStorage, (state) => {
    state.closureStorage = {};
  });
  builder.addCase(resetAccountClosure, (state) => {
    return initialState;
  });
  builder.addCase(resetDetails, (state) => {
    state.details = {};
  });
});
